import type { EnvironmentProviders, Provider } from '@angular/core';

import {
	DesignChangeGatedService,
	DesignChangePendingService,
	DesignChangePresenceService,
} from '@efficiently/client-api-design-changes';
import { provideDesignChangesDataAccess } from '@efficiently/client-data-access-design-changes';

import { DefaultDesignChangeGatedService } from './services/default-design-change-gated.service';
import { DefaultDesignChangePendingService } from './services/default-design-change-pending.service';
import { DefaultDesignChangePresenceService } from './services/default-design-change-presence.service';

export const DESIGN_CHANGES_PROVIDERS: Array<Provider | EnvironmentProviders> = [
	provideDesignChangesDataAccess(),
	{ provide: DesignChangeGatedService, useClass: DefaultDesignChangeGatedService },
	{ provide: DesignChangePendingService, useClass: DefaultDesignChangePendingService },
	{ provide: DesignChangePresenceService, useClass: DefaultDesignChangePresenceService },
];
